// extracted by mini-css-extract-plugin
var _1 = "InfoBubble__InfoBubble___A4JRr";
var _2 = "InfoBubble__body___YhB92";
var _3 = "InfoBubble__close___Y93sB";
var _4 = "InfoBubble__content___TIF0Q";
var _5 = "InfoBubble__tail___mwTDn";
var _6 = "InfoBubble__wiggle___rp3Cy";
export { _1 as "InfoBubble", _2 as "body", _3 as "close", _4 as "content", _5 as "tail", _6 as "wiggle" }
